import { MSColorPicker } from '../../../colorpicker/colorpicker.js';
import { UiFloatModal } from '../../../common/modal/index.js'
import styles from './pens.css'

const gridTemplate = (active, value, color, name) => {
    return `
        <td>
            <input class="pointer" type="checkbox" ${active ? 'checked' : ''}>
        </td>
        <td><ms-colorpicker colorselect="${color}" style="position: relative" width="100%" heigt="25px"></ms-colorpicker></td>
        <td>${name}</td>
        <td>
           <select name=${i18next.t("chartmenupens_value")} class="pointer" value="${value}">
                <option value="0" ${value === 0 ? 'selected' : ''} >${i18next.t("chartmenupens_last")}</option>
                <option value="3"  ${value === 3 ? 'selected' : ''}>${i18next.t("chartmenupens_average")}</option>
                <option value="6" ${value === 6 ? 'selected' : ''}>${i18next.t("chartmenupens_minimum")}</option>
                <option value="5" ${value === 5 ? 'selected' : ''}>${i18next.t("chartmenupens_maximum")}</option>
                <option value="12" ${value === 12 ? 'selected' : ''}>${i18next.t("chartmenupens_difference")}</option>
            </select>
        </td>
    `;
}

const template = () => `
    <style>
       ${styles}
    </style>
        <div class="pens-content">
            <table class="pens-table">
                <thead class="table-head">
                    <tr>
                        <th>${i18next.t("chartmenupens_type")}</th>
                        <th>${i18next.t("chartmenupens_color")}</th>
                        <th>${i18next.t("chartmenupens_name")}</th>
                        <th>${i18next.t("chartmenupens_type_of_value")}</th>
                    </tr>
                </thead>
                <tbody id="table-body" class="table-body"></tbody>
            </table>
            <div class="select-pen" id="select-pen">${i18next.t("chartmenupens_select_pens")}</div>
            <div class="pens-buttons-wrap">
                <div id="pens-btn-apply" class="pens-btn">${i18next.t("apply")}</div>
                <div id="pens-btn-cancel" class="pens-btn">${i18next.t("cancel")}</div>
            </div>
        </div>
        </div>
`;

/**
 * @class ChartMenuPens
 * @classdesc Окно настройки перьев
 * */
export class ChartMenuPens {

    constructor(container, root) {
        this.container = container
        this.root = root
        this.state = this.root.root.state
        this._opened = false;
        this.root.root.checkComponent('ms-colorpicker', MSColorPicker)
        this.initPensModal()
        this.render()
    }

    initPensModal(){
        this.modal = new UiFloatModal(template())
        if(!this.root.root.parentHasPopup) this.modal.root.style.zIndex = 10000100
        this.modal.modalComponent.calculateInitialPosition = () => {
            const { top, left } = this.root.root.getBoundingClientRect()
            return [left, top]
        }
        this.tableBody = this.modal.modalComponent.querySelector('#table-body')
        this.selectPen = this.modal.modalComponent.querySelector('#select-pen')
        this.selectPen.addEventListener('click', this.onSelectPen.bind(this))
        this.applyBtn = this.modal.modalComponent.querySelector('#pens-btn-apply')
        this.cancelBtn = this.modal.modalComponent.querySelector('#pens-btn-cancel')
        this.applyBtn.addEventListener('click', (e) => this.modal.modalComponent.close())
        this.cancelBtn.addEventListener('click', (e) => this.modal.modalComponent.close())
        this.modal.modalComponent.label = i18next.t("chartmenupens_group_setting");
    }

    onSelectPen(e) {
        this.root.root.initSelectTree()
        this.modal.modalComponent.close()
    }

    onCheckbox(id) {
        return (e) => {
            if ($pm.hasPermissions) {
                const options = {
                    cancel: () => { this.render() },
                    customText: `${i18next.t("chartmenupens_changing")} ${this.root.root.elname}`
                };
                $pm.resolveControl(
                    this.root.root,
                    "TrendChangePens",
                    () => this._onCheckbox.call(this, id),
                    options
                );
            } else this._onCheckbox.call(this, id);
        }
    }

    _onCheckbox(id){
        const elem = this.state.pens.find(item => item.id === id)
        this.root.root.changePenByName(elem, "Visibility", !elem.active)
    }

    onColor(id) {
        return (e, color) => {
            if ($pm.hasPermissions) {
                const options = {
                    cancel: () => { this.render() },
                    customText: `${i18next.t("chartmenupens_changing")} ${this.root.root.elname}`
                };
                $pm.resolveControl(
                    this.root.root,
                    "TrendChangePens",
                    () => this._onColor.call(this, color, id),
                    options
                );
            } else this._onColor.call(this, color, id);
        }
    }

    _onColor(color, id){
        const elem = this.state.pens.find(item => item.id === id)
        this.root.root.changePenByName(elem, "Color", color)
    }

    onSelect(name) {
        return (e) => {
            if ($pm.hasPermissions) {
                const options = {
                    cancel: () => { this.render() },
                    customText: `${i18next.t("chartmenupens_changing")} ${this.root.root.elname}`
                };
                $pm.resolveControl(
                    this.root.root,
                    "TrendChangePens",
                    () => this._onSelect.call(this, name, e),
                    options
                );
            } else this._onSelect.call(this, name, e);
        }
    }
    
    _onSelect(name, e){
        const elem = this.state.pens.find(item => item.name === name)
        this.root.root.changePenByName(elem, "DataType", +e.target.value)
    }

    render() {
        this.tableBody.textContent = ''
        const pens = this.state.pens.filter(pen => !pen.hidden)
        const series = this.state.echarts.series
        for (let i = 0; i < pens.length; i++) {
            if (!series.includes(pens[i].serie)) continue
            const { id, active, datatype, serie, name } = pens[i]
            const tr = document.createElement('tr')
            const template = gridTemplate(active, datatype, serie.itemStyle.color, name)
            tr.innerHTML = template
            const inputElem = tr.getElementsByTagName('input')[0]
            const colorElem = tr.getElementsByTagName('ms-colorpicker')[0]
            const selectElem = tr.getElementsByTagName('select')[0]
            inputElem.addEventListener('change', this.onCheckbox.call(this, id))
            colorElem.onColorChange = this.onColor.call(this, id)
            selectElem.addEventListener('change', this.onSelect.call(this, name))
            this.tableBody.appendChild(tr)
        }
    }
}